module.exports = __webpack_public_path__ + "static/media/harmony-logo-horizontal-full-color.f479c78a.svg";